export enum DataTransferEffect {
  Move = 'move',
  None = 'none'
}
